/** biome-ignore-all lint/style/noRestrictedImports: date-fns imports are allowed in @cobliteam/utils only. All other packages must import from @cobliteam/utils/date. */
import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { DEFAULT_LOCALE, DEFAULT_TZ } from './constants';
import { toDate } from './helpers';
import type { DateValue } from './types';

/**
 * Format a date in a specific timezone using pre-defined or custom pattern.
 *
 * Example:
 *   formatDateTZ('2025-11-12T12:00:00Z', "HH:mm zzzz", 'America/Sao_Paulo');
 *   → "09:00 GMT-03:00"
 */
export function formatDateTZ(date: DateValue, pattern: string, timezone: string = DEFAULT_TZ): string {
  const dateObj = toZonedTime(toDate(date), timezone);

  return format(dateObj, pattern, {
    locale: DEFAULT_LOCALE,
  });
}
